var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mycitys"},[_c('van-popup',{style:({ height: '38%' }),attrs:{"position":"bottom"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('van-area',{ref:"myvanarea",attrs:{"title":"省市区","value":_vm.citys,"area-list":_vm.areaList},on:{"confirm":_vm.confirm}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }